var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1409 8.85421C22.5791 8.85421 23.745 7.68828 23.745 6.25004C23.745 4.8118 22.5791 3.64587 21.1409 3.64587C19.7026 3.64587 18.5367 4.8118 18.5367 6.25004C18.5367 6.79637 18.7049 7.3034 18.9924 7.72216L16.3144 12.007C16.1897 11.9887 16.0622 11.9792 15.9325 11.9792C15.4136 11.9792 14.9302 12.131 14.5242 12.3925L12.2466 10.8742C12.273 10.7257 12.2867 10.5728 12.2867 10.4167C12.2867 8.97847 11.1208 7.81254 9.68253 7.81254C8.24428 7.81254 7.07836 8.97847 7.07836 10.4167C7.07836 10.963 7.24659 11.4701 7.53408 11.8888L4.85605 16.1737C4.73141 16.1554 4.60391 16.1459 4.47419 16.1459C3.03595 16.1459 1.87003 17.3118 1.87003 18.75C1.87003 20.1883 3.03595 21.3542 4.47419 21.3542C5.91243 21.3542 7.07836 20.1883 7.07836 18.75C7.07836 18.2037 6.91013 17.6967 6.62265 17.2779L9.30068 12.9931C9.42531 13.0114 9.55281 13.0209 9.68253 13.0209C10.2014 13.0209 10.6849 12.8691 11.0909 12.6076L13.3684 14.1259C13.3421 14.2744 13.3284 14.4273 13.3284 14.5834C13.3284 16.0216 14.4943 17.1875 15.9325 17.1875C17.3708 17.1875 18.5367 16.0216 18.5367 14.5834C18.5367 14.0371 18.3685 13.53 18.081 13.1113L20.759 8.82641C20.8836 8.84472 21.0111 8.85421 21.1409 8.85421Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.50f778bcfac492b88f950125d64684dd.svg";
export { ForwardRef as ReactComponent };